import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
    selector: 'mat-error',
    templateUrl: './field-error.component.html',
    styleUrls: ['./field-error.component.scss']
})
export class FieldErrorComponent implements OnInit, OnDestroy {

    @Input()
    public control: AbstractControl;
    public errors = [];
    @Input()
    customMessage: string;
    private subscription = new Subscription();
    private messages = new Map<string, ErrorMessage>([
        ['required', new ErrorMessage('Dit veld is verplicht')],
        ['iban', new ErrorMessage('Dit is geen correct IBAN')],
        ['maxlength', new ErrorMessage('De maximum lengte is %1', 'requiredLength')],
        ['minlength', new ErrorMessage('De minimale lengte is %1', 'requiredLength')],
        ['max', new ErrorMessage('Het maximum is %1', 'max')],
        ['notAvailable', new ErrorMessage(null)],
        ['userDeleted', new ErrorMessage('Deze gebruiker is verwijderd')],
        ['email', new ErrorMessage('Vul een e-mailadres in')],
        ['invalidPhone', new ErrorMessage('Vul een telefoonnummer in')],
        ['validTime', new ErrorMessage('Tijd is onjuist')],
        ['matDatepickerMin', new ErrorMessage('Datum niet toegestaan')],
        ['matDatepickerMax', new ErrorMessage('Datum niet toegestaan')],
        ['unique', new ErrorMessage('Dit e-mailadres heb je eerder al ingevoerd')]
    ]);

    constructor() {
    }

    ngOnInit() {
        this.parseErrors();
        if (this.control) {
            if (this.control.parent) {
                this.subscription.add(this.control.parent.valueChanges.subscribe(status => {
                    this.parseErrors();
                }));
            }
            if (this.control.parent?.parent) {
                this.subscription.add(this.control.parent.parent.valueChanges.subscribe(status => {
                    this.parseErrors();
                }));
            }
            this.subscription.add(this.control.statusChanges.subscribe(status => {
                this.parseErrors();
            }));
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private parseErrors() {
        this.errors = [];
        if (this.control && typeof this.control.errors !== 'undefined' && this.control.errors) {
            for (const [key, value] of Object.entries(this.control.errors)) {
                const message = this.messages.get(key);
                if (!message) {
                    console.error('No error defined for ' + key);
                } else {
                    let error = message.message;
                    if (error) {
                        message.values.forEach((parseInVal, i) => {
                            error = error.replace(`%${i + 1}`, value[parseInVal]);
                        });
                    } else {
                        error = value;
                    }
                    this.errors.push(error);
                }
            }
        }
    }
}

export class ErrorMessage {
    public values: string[];

    constructor(
        public message: string,
        ...vals: string[]
    ) {
        this.values = vals;
    }
}
